import { connect } from "react-redux";
import CloseRmTicket from "../closedRMTicket";
import { bindActionCreators } from "redux";
import {
  fetchRmTicketDetailsForUpdation,
  postUpdateRca,
  postTicketAssignment,
  postRmRemark,
  getMaterial,
  fetchRmTicketStatus,
  getEquipments,
} from "services/redux/maintenance/rmTicket/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { getSiteData } from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
  pmTicket: state.pmTicketReducer.pmTicket,
  rmTicketDetailsForUpdation: state.rmTicketReducer.rmTicketDetailsForUpdation,
  rmStatus: state.rmTicketReducer.rmStatus,
  materials: state.rmTicketReducer.materials,
  equipments: state.rmTicketReducer.equipments,
  siteData: state.leadDataReducer.siteData,
  // distanceDetails: state.leadDataReducer.distanceDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postUpdateRca,
      documentUploadUrl,
      postRmRemark,
      getMaterial,
      fetchRmTicketStatus,
      fetchRmTicketDetailsForUpdation,
      postTicketAssignment,
      getEquipments,
      // getSiteData,
      // getDistanceData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CloseRmTicket);
